import * as UI from '@brewlogix/blx-ui'

import AmenitiesPill from './Amenities/AmenitiesPill'
// Constants
import { Location } from 'src/types/schema/graphql'
import React from 'react'
import classNames from 'classnames'
import { parseEnumLabel } from 'src/util/helpers'
import tailwindConfig from '@brewlogix/blx-ui/tailwind.config'

interface IBrewOptions {
    location: Location
}

const BrewOptions: React.FC<IBrewOptions> = ({ location }) => {
    const icons = Object.keys(tailwindConfig.theme.icons)
    const getIconSlug: (value: string) => string = (a: string) => {
        return a.replace(/_/g, '')
    }
    return (
        <div className={classNames('mt-20 space-y-6')} id='amenities'>
            <UI.Heading
                text='Brew Options'
                size='h4'
                type='h2'
                customClasses='text-xl lg:text-2xl text-gray-500 font-extrabold'
            />
            <div className='mt-4 grid grid-cols-2 items-baseline gap-3'>
                {location.traits.brewOptions.map((a, i) => {
                    const iconExists = icons.includes(getIconSlug(a.toString()))
                    return (
                        <div key={`cell-${a}`} className='flex flex-wrap justify-start gap-2'>
                            {iconExists ? (
                                <AmenitiesPill item={a} />
                            ) : (
                                <UI.Pill
                                    theme='default'
                                    shape='full'
                                    label={parseEnumLabel(a)}
                                    size='md'
                                    customClasses='border-0 bg-white -ml-3'
                                />
                            )}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default BrewOptions
